<template>
  <div>
    <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-select
              v-model="searchForm.project"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择发布平台"
              style="width: 100%"
            >
              <a-select-option v-for="item in lineListLv1" :key="item.project" :value="item.project">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="优惠券名称" prop="coupon_name_keyword">
            <a-input
              v-model="searchForm.coupon_name_keyword"
              allowClear
              placeholder="请输入优惠券名称"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>

        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="优惠券类型" prop="coupon_type">
            <a-select v-model="searchForm.coupon_type" allowClear placeholder="请选择优惠券类型">
              <a-select-option v-for="(value, key) in COUPON_TYPE" :key="key" :value="key">
                {{ value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态" prop="state">
            <a-select
              v-model="searchForm.state"
              allowClear
              placeholder="请选择状态"
              style="width: 100%"
            >
              <a-select-option v-for="(value, key) in COUPON_STATE" :key="key" :value="key">{{ value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="优惠券ID" prop="id">
            <a-input v-model="searchForm.id" allowClear placeholder="请输入优惠券ID" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 搜索按钮 -->
    <a-row type="flex" justify="space-between">
      <a-button type="primary" @click="addCoupon"> <a-icon type="plus-circle" />添加优惠券 </a-button>
      <div>
        <a-button type="primary" icon="search" style="margin-right:18px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </a-row>

    <!-- 表格 -->
    <a-table
      size="middle"
      row-key="id"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :pagination="pagination"
      style="margin-top: 20px"
      @change="handleTableChange"
      :scroll="{ x: 1500, y: 'auto' }"
    >
      <template slot="project" slot-scope="text, record">
        <a-tag color="blue">{{ getLineName(record) }}</a-tag>
      </template>

      <!-- 优惠券类型 -->
      <template slot="coupon_type" slot-scope="text, record">
        <div>{{ showName('COUPON_TYPE', record.coupon_type) }}</div>
        <div class="gray-text-6 font12">
          {{ showName('COUPON_PROPERTY', record.coupon_property) }}
        </div>
      </template>

      <!-- 优惠券门槛 -->
      <template slot="threshold" slot-scope="text, record">
        <div>{{ record.coupon_type == 1 ? record.coupon_amount : `${+record.coupon_amount}折` }}</div>
        <div class="gray-text-6 font12">
          {{ record.coupon_threshold == 0 ? '无门槛' : `满${+record.coupon_threshold}可用` }}
        </div>
      </template>

      <!-- 使用/领取/发放 -->
      <template slot="receive_info" slot-scope="text, record">
        <a class="use-info-wrapper" @click="jumpReceiveRecord(record)">
          <span>{{ record.statistics ? (record.statistics.use_total || 0) : 0 }}</span>
          <span>{{ record.statistics ? (record.statistics.receive_total || 0) : 0 }}</span>
          <span>{{ record.coupon_num == 0 ? '不限制' : record.coupon_num }}</span>
        </a>
      </template>

      <!-- 领取有效期 -->
      <template slot="rec_date_range" slot-scope="text, record">
        <div class="">
          <div>开始：{{ record.rec_start_at | formatDate }}</div>
          <div>结束：{{ record.rec_end_at | formatDate }}</div>
        </div>
      </template>

      <!-- 使用有效期 -->
      <template slot="use_date_range" slot-scope="text, record">
        <span v-if="record.use_type == '1'">长期有效</span>
        <div class="" v-else-if="record.use_type == '2'">
          <div>开始：{{ record.use_eff_start_at | formatDate }}</div>
          <div>结束：{{ record.use_eff_end_at | formatDate }}</div>
        </div>
        <span v-else-if="record.use_type == '3'">
          {{ `从领取日起${record.use_rec_eff_day}天内有效` }}
        </span>
      </template>

      <!-- 创建 -->
      <template slot="created_info" slot-scope="text, record">
        <div class="">
          <div>创建：{{ record.createdUser && `${record.createdUser.name} (${record.createdUser.number})` }}</div>
          <div>时间：{{ record.created_at | formatDate }}</div>
        </div>
      </template>

      <template slot="state" slot-scope="text">
        <span :class="`state-${text}`">{{ showName('COUPON_STATE', text) }}</span>
      </template>
      <!-- 状态 1.草稿 2待开始 3进行中 4暂停 5已过期 6已取消 -->
      <template slot="operator" slot-scope="text, record">
        <a-button size="small" type="link" @click="handleEdit(record)" v-if="['1'].includes(record.state)">编辑</a-button>
        <a-button size="small" type="link" @click="handleView(record)" v-if="['1','2','3','4', '5','6'].includes(record.state)">查看</a-button>
        <a-button size="small" type="link" @click="handleDel(record)" v-if="['1'].includes(record.state)">删除</a-button>
        <a-button size="small" type="link" @click="handlePaused(record)" v-if="['3'].includes(record.state)">暂停</a-button>
        <a-button size="small" type="link" @click="handleContinue(record)" v-if="['4'].includes(record.state)">继续</a-button>
        <a-button size="small" type="link" @click="handleCouponCancel(record)" v-if="['2','3', '4'].includes(record.state)">取消</a-button>
      </template>
    </a-table>

    <!-- 新增、编辑模板 -->
    <a-modal v-model="visible" title="选择品牌" @cancel="handleCancel">
      <a-form-model
        ref="addFormRef"
        :model="addForm"
        :rules="addRules"
        labelAlign="left"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="选择平台" prop="project">
          <a-select
            v-model="addForm.project"
            placeholder="请输入或选择"
            show-search
            allowClear
            :filter-option="filterOption"
          >
            <a-select-option v-for="item in lineListLv1" :key="item.project" :value="item.project">
              {{ item.org }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">取 消</a-button>
        <a-button key="submit" type="primary" :loading="sbtloading" @click="handleOk">下一步</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import moment from 'moment'
import { computed, reactive, onMounted, onUnmounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import pagination from '@/composables/pagination'
import computedFun from '@/views/coupon/computed/'
import api from '@/api/'
import { couponList, couponUpdateState, couponDelete } from '@/api/coupon/index'

import { cloneDeep } from 'lodash'

const formReset = {
  project: undefined,
  coupon_name_keyword: undefined,
  coupon_type: undefined,
  state: undefined,
  id: undefined
}
const addFormReset = {
  project: undefined
}

const columns = [
  {
    title: '优惠券ID',
    dataIndex: 'id',
    width: 80,
    align: 'center'
  },
  {
    title: '所属品牌',
    dataIndex: 'org',
    align: 'left',
    width: 90,
    scopedSlots: { customRender: 'project' }
  },
  {
    title: '优惠券名称',
    dataIndex: 'coupon_name',
    width: 200,
    align: 'left'
  },
  {
    title: '优惠券类型',
    dataIndex: 'type',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'coupon_type' }
  },
  {
    title: '面额/使用门槛',
    dataIndex: 'threshold',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'threshold' }
  },
  {
    title: '使用/领取/发放',
    dataIndex: 'receive_info',
    align: 'left',
    width: 160,
    scopedSlots: { customRender: 'receive_info' }
  },
  {
    title: '排序值',
    dataIndex: 'coupon_sort',
    align: 'center',
    width: 60
    // scopedSlots: { customRender: 'sort' }
  },
  {
    title: '领取有效期',
    dataIndex: 'rec_date_range',
    align: 'left',
    width: 185,
    scopedSlots: { customRender: 'rec_date_range' }
    // customRender(text) {
    //   return parseTime(text)
    // }
  },
  {
    title: '使用有效期',
    dataIndex: 'use_date_range',
    align: 'left',
    width: 185,
    scopedSlots: { customRender: 'use_date_range' }
  },
  {
    title: '状态',
    dataIndex: 'state',
    align: 'left',
    width: 90,
    scopedSlots: { customRender: 'state' }
  },
  {
    title: '创建',
    dataIndex: 'created_info',
    align: 'left',
    width: 185,
    scopedSlots: { customRender: 'created_info' }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 200,
    fixed: 'right',
    scopedSlots: { customRender: 'operator' }
  }
]

export default {
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columns,
      loading: false,
      visible: false,
      sbtloading: false,
      templateList: [],
      platformList: [], // 发布平台
      searchForm: cloneDeep(formReset),

      addForm: cloneDeep(addFormReset),
      addRules: {
        project: [{ required: true, message: '请选择平台', trigger: 'blur' }]
      }
    })

    const lineListLv1 = computed(() => {
      return state.platformList.filter(item => {
        return item.depth === 0
      })
    })

    onMounted(() => {
      methods.getPlatform()
      methods.getList()
    })
    onUnmounted(async () => {})

    const methods = {
      addCoupon() {
        _this.visible = true
      },
      search() {
        _this.pagination.current = 1
        _this.getList()
      },
      // 修改状态
      async handleCouponUpdateState(id, state) {
        if (!id) return
        await couponUpdateState({ id, state })
        _this.getList()
      },
      getSearchParams() {
        const queryParams = { ...state.searchForm }
        if (Array.isArray(queryParams.publish_at) && queryParams.publish_at.length === 2) {
          queryParams.start_date = moment
            .unix(queryParams.publish_at[0])
            .startOf('day')
            .unix()
          queryParams.end_date = moment
            .unix(queryParams.publish_at[1])
            .endOf('day')
            .unix()
        } else {
          delete queryParams.start_date
          delete queryParams.end_date
        }
        delete queryParams.publish_at
        return queryParams
      },
      async getList() {
        try {
          _this.loading = true
          const res = await couponList({
            ...methods.getSearchParams(),
            page: _this.pagination.current,
            per_page: _this.pagination.pageSize
          })
          const { list, pagination } = res.data
          _this.data = list
          _this.pagination.total = +pagination.total
          _this.loading = false
        } catch (error) {
          _this.loading = false
        }
      },

      // 获取平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },
      // 发布平台
      getLineName(record) {
        return state.platformList.find(item => String(item.project) === String(record.project))?.org ?? '--'
      },

      // 清除
      handleClear() {
        state.searchForm = cloneDeep(formReset)
        _this.search()
      },

      commonConfirm(title, content) {
        return new Promise((resolve, reject) => {
          _this.$confirm({
            title,
            content,
            okText: '确定',
            cancelText: '取消',
            onOk: () => resolve(true),
            // eslint-disable-next-line prefer-promise-reject-errors
            onCancel: () => reject(false)
          })
        })
      },
      jumpReceiveRecord(row) {
        const id = row.id
        const { href } = this.$router.resolve({
          name: 'receiveRecords',
          query: {
            id
          }
        })
        window.open(href, '_blank')
      },
      /**
       * 编辑
       * @param {} row
       */
      handleEdit(row) {
        const { project, id } = row
        this.$router.push({
          name: 'couponEdit',
          params: {
            id
          },
          query: {
            project
          }
        })
      },
      /**
       * 暂停
       */
      async handlePaused(record) {
        await _this
          .commonConfirm('用户已经领取的优惠券仍会保留，确定要暂停吗？')
          .then(() => {
            methods.handleCouponUpdateState(record.id, 4)
          })
          .catch(() => {})
      },
      /**
       * 继续
       */
      async handleContinue(record) {
        await _this
          .commonConfirm('确定要重新启动吗？')
          .then(() => {
            methods.handleCouponUpdateState(record.id, 3)
          })
          .catch(() => {})
      },
      /**
       * 取消
       */
      async handleCouponCancel(record) {
        await _this
          .commonConfirm('用户已经领取的优惠券仍会保留，确定要取消吗？')
          .then(() => {
            methods.handleCouponUpdateState(record.id, 6)
          })
          .catch(() => {})
      },
      /**
       * 查看详情
       * @param {} row
       */
      handleView(row) {
        const { project } = row
        this.$router.push({
          name: 'couponDetail',
          params: {
            id: row.id
          },
          query: {
            project
          }
        })
      },
      async handleDel(row) {
        await _this
          .commonConfirm('确定要删除吗？')
          .then(async () => {
            const res = await couponDelete({ id: row.id })
            if (_this.$validate(res)) {
              _this.$message.success(`删除成功！`)
              methods.getList()
            }
          })
          .catch(() => {})
        // _this.$confirm({
        //   title: `确定要删除吗？`,
        //   okText: '确定',
        //   cancelText: '取消',
        //   onOk: async () => {
        //     const res = await couponDelete({ id: row.id })
        //     if (_this.$validate(res)) {
        //       _this.$message.success(`删除成功！`)
        //       methods.getList()
        //     }
        //   }
        // })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleCancel() {
        _this.visible = false
        state.addForm = cloneDeep(addFormReset)
        _this.$refs.addFormRef.resetFields()
        _this.$refs.addFormRef.clearValidate()
      },
      handleOk() {
        _this.$refs.addFormRef.validate(valid => {
          if (valid) {
            this.$router.push({
              name: 'couponEdit',
              query: {
                ...state.addForm
              }
            })
          }
        })
      }
    }

    return {
      lineListLv1,
      ...toRefs(state),
      ...computedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>
<style lang="less">
// 1.草稿 2待开始 3进行中 4暂停 5已过期 6已取消
.state {
  &-0 {
    color: #f59a23;
  }
  &-1 {
    color: #f59a23;
  }
  &-2 {
    color: #f59a23;
  }
  &-3 {
    color: #1fb749;
  }
  &-4 {
    color: #555555;
  }
  &-5 {
    color: #555555;
  }
  &-6 {
    color: 555555;
  }
}
.use-info-wrapper {
  display: flex;
  align-items: center;
  flex-direction: row;
  position: relative;
  & > span:not(:last-child):after {
    content: '';
    background: #bfbfbf;
    width: 1px;
    height: 12px;
    display: inline-block;
    margin: 0 8px;
  }
}
</style>
